export type RuTranslationsType = typeof ruTranslations;

export const ruTranslations = {
  translation: {
    agreementFile: 'Правила СЖЗ.pdf',
    keyInformationDocument: 'Ключевой информационный документ',
    no: 'Нет',
    questionnaire: {
      blockHeader: 'Вы несколько раз ввели неверно SMS-код',
      blockMessage:
        'Чтобы обезопасить ваши данные, мы временно заблокировали доступ.Попробуйте ещё раз через 24 часа или обратитесь в отделение',
      doYouHaveAnyIllnesses: 'Имеются ли у вас какие-либо заболевания из нижеперечисленных?',
      enterCode: 'Введите код',
      incorrectSmsCode: 'Введен неверный СМС-код. Попробуйте еще раз',
      incorrectSmsCodeMoreOne: 'Неверный код. Осталось {{count}} попытки',
      incorrectSmsCodeOne: 'Неверный код. Осталась {{count}} попытка',
      insuranceQuestionnaire: 'Анкета для страхования',
      notFound: 'Анкета не найдена!',
      notFoundDescription: 'Заявка с данным ID не существует.',
      ok: 'Понятно',
      processedApplication: 'Данная заявка была уже ранее отправлена',
      processedApplicationDescription: '',
      recallCodeAgain: 'Отправить код повторно через {{count}} секунд',
      requestAgain: 'Отправить код повторно',
      sentCodeToPhoneNumber: 'Отправили SMS на номер',
      surveyIllnessOptions: {
        cardiovascularSystem: 'Сердечно-сосудистая система',
        diabetes: 'Сахарный диабет',
        hepatitisBOrC: 'Гепатит В или С',
        kidneys: 'Почек',
        oncology: 'Онкологические',
        respiratorySystem: 'Легкие или дыхательные пути',
      },
    },
    yes: 'Да',
  },
};
